import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { toastrRemove } from '../../../actions';

import ToastrItem from './ToastrItem/ToastrItem';

import './Toastr.scss';

function Toastr() {

    const { messages } = useSelector(state => state.toastr);
    const dispatch = useDispatch();

    const _handleClose = React.useCallback((index) => {
        dispatch(toastrRemove(index))
    }, [dispatch]);

    return (
        <div className="ToastrWrapper">
            {messages.map((message) => (
                <ToastrItem
                    key={message.index}
                    message={message}
                    onClose={_handleClose}
                />
            ))}
        </div>
    )
}

export default Toastr;